import { Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function TotalEmployeesCard() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts()

  return (
    <StatisticsCard
      title={t('statistics.totalEmployees.title')}
      value={data?.data?.total ?? '—'}
      CustomIcon={Users}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
